import { createModalStore } from '@/shared/lib/modal';
import { PricingEntryPoint } from '@/shared/lib/pricingAttribution';

type OnscreenPaywallModalState = {
  pricingEntryPoint: PricingEntryPoint;
  // Runs before the pricing page opens, e.g. to close the upload modal the paywall was opened from.
  onLeaveForPricing?: () => void;
};

const initialState: OnscreenPaywallModalState = {
  pricingEntryPoint: 'visual_translation_tab',
  onLeaveForPricing: undefined,
};

export const useOnscreenPaywallModalStore = createModalStore<OnscreenPaywallModalState>(initialState);
